import React, {FC, useEffect, useState} from 'react';
import {Container, Row, Col, BreadcrumbItem, Alert} from 'reactstrap';
import {Link} from 'react-router-dom';
import BreadCrumbs from 'components/BreadCrumbs';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons';

const Calendar: FC = ({product, productInPath}) => {
  const [height, setHeight] = useState(500);

  useEffect(() => {
    const handler = (ev: MessageEvent<{type: string, message: string}>) => {
      if (ev.data.type == 'dimensions' && ev.origin == 'https://www.addevent.com') {
        var h = ev.data.h;
        setHeight(h);
      }
    };

    window.addEventListener('message', handler);

    // Don't forget to remove addEventListener
    return () => window.removeEventListener('message', handler);
  }, []);
  return (
    <Container>
      <BreadCrumbs>
        <BreadcrumbItem tag={Link} to={`/products/${productInPath}`}>
          {product.title}
        </BreadcrumbItem>
        <BreadcrumbItem active tag="span">
          Schedule
        </BreadcrumbItem>
      </BreadCrumbs>
      <h1 className="mt-0">Plant-Based Coaching Certification Event Schedule</h1>
      <Row>
        <Col>
          <Alert color="info">
            <FontAwesomeIcon icon={faInfoCircle} />
            &nbsp;&nbsp;
            <a
              href="https://cdn.foodrevolution.org/members/pdf/pbcc/Plant-Based%20Coaching%20Certification%20-%20Schedule%20Directions.pdf"
              target={'_blank'}
              className="alert-link"
            >
              How to add the schedule to your personal calendar
            </a>
          </Alert>
          <iframe
            className="mt-5"
            src={
              productInPath === 'pbcc'
                ? 'https://calendar.google.com/calendar/embed?src=c_741a10b31775a647fbd442021da48288e1b107e8b03f350a8174f0184dfb7c4f%40group.calendar.google.com'
                : 'https://www.addevent.com/calendar/vP622574/embed/?id=vP622574&calendars=vP622574&calendars_sel=vP622574&config=true&title=&titleshow=false&today=true&datenav=true&date=true&monthweektoggle=true&subscribebtn=true&swimonth=true&swiweek=true&swischedule=true&print=true&timezone=true&defaultview=month&firstday=1&datetimeformat=1#vP622574'
            }
            style={{width: '100%', height: `${height}px`, border: 0}}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Calendar;
